<template>
  <v-row>
    <v-col>
      <v-col class="d-flex justify-space-between mx-auto flex-wrap container">
        <ToolbarTitles :title="title" />
        <ButtonsCardList @cardView="cardView" />
      </v-col>
      <div v-if="showCard" class="container">
        <CardsView
          :items="costCenters"
          :openDialog="openDialog"
          @refreshItems="refreshItems"
          :showRefresh="true"
        />
      </div>
      <div v-if="!showCard" class="container">
        <TableWithSearch
          :items="costCenters"
          :headers="allHeaders"
          :openDialog="openDialog"
          @headersUpdated="updateHeaders"
          @refreshItems="refreshItems"
          :showRefresh="true"
        />
      </div>
      <v-dialog
        v-model="opencostCenters"
        :fullscreen="mode === 'Editar centro de costo'"
        :max-width="maxWidth[0]"
        hide-overlay
        persistent
        @keydown.esc="reset(false)"
      >
        <FormDataTable
          :items="dataInputs"
          @save="saveForm"
          @cancel="reset"
          :maxWidth="maxWidth[0]"
          :mode="mode"
          :show="true"
          :itemsSelect="dataSelects"
          :multiple="true"
          :showDate="true"
          :showCheck="true"
          :key="formKey"
        />
      </v-dialog>
      <DeleteDialog
        :showDialog="openDelete"
        :title="titleDelete"
        :confirmDelete="deleteItem"
        :cancelDelete="cancelDelete"
        :maxWidth="maxWidth[2]"
      />
    </v-col>
    <v-dialog v-model="isLoading" class="dialog__loader" :overlay-opacity="0.3">
      <Loader :loading="isLoading" />
    </v-dialog>
    <Snackbar :alert="alert" :color="color" :textAlert="textAlert" />
  </v-row>
</template>
<script>
import costCenters from "@/store/centrosDeCosto/costCenters";
import clocks from "@/store/centrosDeCosto/clocks";
import configTable from "@/store/configuracionDeTablas/configTable.js";
import date from "@/store/common/date";
import concepts from "@/store/conceptos/concepts";
import CardsView from "@/components/Complement/CardsView.vue";
import TableWithSearch from "@/components/Complement/TableWithSearch.vue";
import ToolbarTitles from "@/components/Complement/ToolbarTitles.vue";
import ButtonsCardList from "@/components/Complement/ButtonsCardList.vue";
import FormDataTable from "./Form/FormDataTable.vue";
import DeleteDialog from "@/components/Complement/DeleteDialog.vue";
import Snackbar from "@/components/Complement/Snackbar.vue";
import Loader from "@/components/Complement/Loader.vue";

export default {
  components: {
    TableWithSearch,
    CardsView,
    ToolbarTitles,
    ButtonsCardList,
    FormDataTable,
    DeleteDialog,
    Snackbar,
    Loader,
  },
  data() {
    return {
      title: this.$tc("costCenter.costCenters"),
      titleDelete: this.$tc("costCenter.toCostCenters"),
      isLoading: true,
      maxWidth: ["600px", "500px", "400px"],
      color: "#82A1D0",
      alert: false,
      textAlert: "",
      showCard: true,
      itemId: null,
      dataInputs: [
        {
          name: "name",
          label: this.$tc("costCenter.nameCostCenters"),
          data: "",
          type: "text",
          rules: [
            (v) => !!v || this.$tc("editRegistrations.requerid"),
            (v) =>
              v.length <= 50 || this.$tc("costCenter.rulesDataName50chart"),
          ],
        },
        {
          name: "codRegExt",
          label: this.$tc("costCenter.ExtendedRegistrationCode"),
          data: "000",
          type: "text",
          rules: [
            (v) =>
              !!v ||
              !this.dataSelects[1].data.length > 0 ||
              this.$tc("editRegistrations.requerid"),
            (v) =>
              v.length <= 3 || this.$tc("costCenter.rulesDatacodRegExt3chart"),
          ],
        },
      ],
      headers: {
        centroDeCosto: [
          {
            text: "Nombre",
            value: "name",
            class: "primary secondary--text",
            visible: true,
          },
          {
            text: "Acciones",
            value: "actions",
            sortable: false,
            class: "primary secondary--text",
            visible: true,
            width: "100px",
          },
        ],
        clocks: [
          {
            text: "Nombre",
            value: "nombre",
            class: "primary secondary--text",
            visible: true,
          },
          {
            text: "Desde",
            value: "fecDesde",
            class: "primary secondary--text",
            visible: true,
            sortable: false,
          },
          {
            text: "Hasta",
            value: "fecHasta",
            class: "primary secondary--text",
            visible: true,
            sortable: false,
          },
          {
            text: "Código de registración extendida",
            value: "codRegisEx",
            class: "primary secondary--text",
            visible: true,
          },
          {
            text: "Acciones",
            value: "actions",
            class: "primary secondary--text",
            visible: true,
            sortable: false,
            width: "100px",
          },
        ],
      },
      headersConcept: [
        {
          text: "Nombre",
          value: "name",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Acciones",
          value: "actions",
          sortable: false,
          class: "primary secondary--text",
          visible: true,
          width: "100px",
        },
      ],
      formKey: 0,
      titleTable: this.$tc("costCenter.costCenters"),
    };
  },
  async mounted() {
    try {
      configTable.commit("setColums", []);
      let nameTable = this.titleTable;
      configTable
        .dispatch("getColumsTableName", nameTable)
        .then((result) => {
          if (
            configTable.state.colums.length === 0 ||
            Object.values(this.allColums).reduce(
              (sum, array) => sum + array.length,
              0
            ) !==
              Object.values(this.headers).reduce(
                (sum, array) => sum + array.length,
                0
              )
          ) {
            this.saveConfigColumns();
          }
        })
        .catch((error) => {
          console.error("Error occurred:", error);
        });
      await Promise.all([
        concepts.dispatch("getConcepts"),
        concepts.dispatch("getLiquidationModels"),
        clocks.dispatch("getClocks"),
        costCenters.dispatch("getCostCenters"),
      ]);

      this.isLoading = false;
    } catch (error) {
      console.error(error);
    }
  },
  computed: {
    allHeaders() {
      return configTable.state?.colums?.centroDeCosto;
    },
    allColums() {
      return configTable.state.colums;
    },
    costCenters() {
      return costCenters.state.costCenters;
    },
    clocks() {
      return clocks.state.clocks;
    },
    padding() {
      return costCenters.state.paddingNav;
    },
    salaries() {
      return concepts.state.salaries;
    },
    liquidations() {
      return concepts.state.liquidations;
    },
    dataSelects() {
      return [
        {
          name: "modelsLiquidation",
          label: this.$tc("costCenter.modelsLiquidation"),
          data: [],
          items: this.liquidations,
          itemsValue: "liqmodelId",
          itemsText: "name",
          rules: [
            (v) =>
              (v !== null && v !== undefined && v !== "") ||
              this.$tc("editRegistrations.requerid"),
          ],
          icon: "",
        },
        {
          name: "clocks",
          label: this.$tc("costCenter.clocks"),
          data: [],
          items: this.clocks,
          itemsValue: "id",
          itemsText: "name",
          rules: [
            (v) =>
              (v !== null && v !== undefined && v !== "") ||
              this.$tc("editRegistrations.requerid"),
          ],
          icon: "mdi-pencil",
        },
      ];
    },
    mode: {
      get() {
        return costCenters.state.mode;
      },
      set(newValue) {
        return newValue;
      },
    },
    opencostCenters: {
      get() {
        return costCenters.state.open;
      },
      set(newvalue) {
        return newvalue;
      },
    },
    openDelete: {
      get() {
        return costCenters.state.openDelete;
      },
      set(newvalue) {
        return newvalue;
      },
    },
  },
  methods: {
    async refreshItems() {
      await costCenters.dispatch("getCostCenters");
    },
    updateHeaders(headers) {
      const updatedColums = {
        ...configTable.state.colums,
        centroDeCosto: headers,
      };

      configTable.commit("setColums", updatedColums);
      this.saveConfigColumns();
    },
    saveConfigColumns() {
      let columnsToSave = this.allColums;
      if (
        columnsToSave === undefined ||
        Object.values(this.allColums).reduce(
          (sum, array) => sum + array.length,
          0
        ) !==
          Object.values(this.headers).reduce(
            (sum, array) => sum + array.length,
            0
          ) ||
        columnsToSave.length === 0
      ) {
        columnsToSave = this.headers;
      }
      const configData = {
        operId: Number(localStorage.getItem("operId")),
        nameTable: this.titleTable,
        json: JSON.stringify(columnsToSave),
      };

      configTable.commit("setNew", configData);
      configTable.dispatch("new").then(() => {
        configTable.commit("setNew", []);
      });
    },
    addConcept(form) {
      const payload = this.buildPayload(form);
      costCenters.commit("setNew", payload);
      costCenters
        .dispatch("add")
        .then(() => {
          this.showAlert(
            this.$tc("costCenter.addCostCenterSuccess"),
            "#82A1D0"
          );
        })
        .catch((e) => {
          this.showAlert(this.$tc("costCenter.addCostCenterError"), "#ff8d58");
        });
      this.reset(false);
    },

    buildPayload(formData) {
      const relojesIds =
        formData.clocks.trim() !== ""
          ? formData.clocks
              .split(",")
              .map(Number)
              .filter((id) => id !== 0)
          : [];
      const relojes =
        relojesIds.length > 0
          ? relojesIds.map((relojId) => {
              const relojObject = {
                relojId,
                codRegisEx: formData.codRegExt,
                fecDesde: date.state.dateFrom,
              };

              if (!date.state.checkTo) {
                relojObject.fecHasta = date.state.dateTo;
              }

              return relojObject;
            })
          : undefined;

      const liqModelos = formData.modelsLiquidation
        ? formData.modelsLiquidation.split(",").map(Number)
        : undefined;

      const payload = {
        nombre: formData.name,
      };

      if (relojes) {
        payload.relojes = relojes;
      }

      if (liqModelos) {
        payload.liqModelos = liqModelos;
      }

      return payload;
    },
    buildPayloadEdit(formData) {
      const liqModelos = formData.modelsLiquidation
        ? formData.modelsLiquidation.split(",").map(Number)
        : undefined;

      const payload = {
        nombre: formData.name,
      };

      if (liqModelos) {
        payload.liqModelos = liqModelos;
      }

      return payload;
    },

    showAlert(text, color) {
      this.alert = true;
      this.textAlert = text;
      this.color = color;

      setTimeout(() => {
        this.alert = false;
      }, 3000);
    },

    async editConcept(form) {
      const payload = this.buildPayloadEdit(form);
      payload.id = this.itemId;
      await costCenters.commit("setEdit", payload);
      await costCenters
        .dispatch("edit")
        .then(() => {
          this.showAlert(
            this.$tc("costCenter.editCostCenterSuccess"),
            "#82A1D0"
          );
        })
        .catch((e) => {
          this.showAlert(this.$tc("costCenter.editCostCenterError"), "#ff8d58");
        });
      this.reset(false);
    },

    saveForm(items) {
      switch (this.typeForm) {
        case "add":
          this.addConcept(items);
          break;
        case "edit":
          this.editConcept(items);
          break;
        default:
          break;
      }
    },

    resetDate() {
      const day = new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10);
      date.commit("setDateFrom", day);
      date.commit("setDateTo", null);
    },

    reset(value) {
      this.resetDate();
      costCenters.commit("setOpen", value);
      this.dataInputs.forEach((item) => {
        item.data = "";
      });
      this.dataSelects.forEach((item) => {
        item.data = "";
      });
    },
    cardView(value) {
      this.showCard = value;
    },
    formatDate(dateString) {
      const date = new Date(dateString);
      const year = date.getUTCFullYear();
      const month = String(date.getUTCMonth() + 1).padStart(2, "0");
      const day = String(date.getUTCDate()).padStart(2, "0");

      return `${day}-${month}-${year}`;
    },
    async setEdit(item) {
      await costCenters.dispatch("getCostCentersId", this.itemId);
      this.dataInputs[0].data = item.name;
      if (costCenters.state.edit) {
        this.dataSelects[0].data = costCenters.state.edit.liqModelos
          ? costCenters.state.edit.liqModelos.map(
              (modelo) => modelo.liqModeloId
            )
          : [];
      } else {
        this.dataSelects[0].data = [];
      }

      if (costCenters.state.edit.relojes) {
        this.dataSelects[1].data = costCenters.state.edit.relojes.map(
          (reloj) => {
            reloj.fecDesde = this.formatDate(reloj.fecDesde);
            reloj.fecHasta = reloj.fecHasta
              ? this.formatDate(reloj.fecHasta)
              : "";
            return reloj;
          }
        );
      } else {
        this.dataSelects[1].data = [];
      }
      costCenters.commit("setOpen", true);
    },
    async openDialog(type, item) {
      this.typeForm = type;

      switch (this.typeForm) {
        case "add":
          this.formKey++;
          costCenters.commit("setMode", this.$tc("costCenter.addCostCenters"));
          costCenters.commit("setOpen", true);
          break;
        case "edit":
          this.itemId = item.id;
          costCenters.commit("setMode", this.$tc("costCenter.editCostCenters"));
          await this.setEdit(item);
          this.formKey++;

          break;
        case "delete":
          costCenters.commit("setOpenDelete", true);
          this.itemToDelete = item.id;
          break;

        default:
          break;
      }
    },

    deleteItem() {
      costCenters.commit("setItemDelete", this.itemToDelete);
      costCenters
        .dispatch("delete")
        .then(() => {
          this.openDelete = false;
          costCenters.commit("setOpenDelete", false);
          this.showAlert(
            this.$tc("costCenter.deleteCostCenterSucces"),
            "#82A1D0"
          );
        })
        .catch((e) => {
          this.showAlert(
            this.$tc("costCenter.deleteCostCenterError"),
            "#ff8d58"
          );
        });
    },

    cancelDelete() {
      this.openDelete = false;
      costCenters.commit("setOpenDelete", false);
    },
  },
};
</script>
<style>
.container {
  max-width: 100%;
  padding-top: 1vh;
  padding-bottom: 1vh;
}
</style>
